import { findPathInTree } from "@/utils/findPathInTree";
import { useControllableValue } from "ahooks";
import { last } from "lodash";
import { useMemo } from "react";
import { HBCascader } from "../HBCascader";
import { useCrowdTags } from "./useCrowdTag";

export function NewJobSelect(props) {
  const { jobs } = useCrowdTags();

  const [value, setValue] = useControllableValue(props);

  const cascaderValue = useMemo(() => {
    return findPathInTree(jobs, value) || null;
  }, [value, jobs]);

  return (
    <HBCascader
      options={jobs}
      value={cascaderValue}
      onChange={(value) => {
        setValue(last(value));
      }}
      placeholder={props.placeholder}
      displayRender={(label) => {
        return last(label);
      }}
    />
  );
}
